export const RouteIndex = {
    login: '/login/',
    auth: '/auth/magic-link',
    googleCallback: '/auth/google/callback',
    signUp: '/sign-up/',
    documentList: '/',
    newDocument: '/document/new/',
    documentDetail: {
        edit: '/document/:documentId/edit/',
        editRevision: '/document/:documentId/edit/:revisionId',
        bankTransferPayment: '/document/:documentId/bank-transfer/',
        paymentReturn: '/document/:documentId/payment-return/',
    },
    payment: {
        return: '/payment/return',
    },
    wallet: '/wallet/',
    topUpCredit: '/wallet/top-up/',
    checkout: '/wallet/checkout/',
    bankTransferPayment: '/wallet/bank-transfer/',
    creditPaymentReturn: '/wallet/payment-return/:orderId',
    paymentSuccess: '/wallet/payment-success/',
    accountSettings: '/account/settings/',
    forgotPassword: '/forgot-password/',
    resetPassword: '/reset-password/',
    termAndConditions: '#',
    privacyPolicy: '#',
};
